import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const KioskAuthContext = createContext();

export default function KioskAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("kiosk_token") || "");
  const [ownerId, setOwnerId] = useState(() => localStorage.getItem("kiosk_owner_id") || "");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Logs only once during initial mount – no dependency required
    const savedToken = localStorage.getItem("kiosk_token");
    const savedOwnerId = localStorage.getItem("kiosk_owner_id");

    console.log("🔄 Context Initialized");
    console.log("📌 token from localStorage =", savedToken);
    console.log("📌 ownerId from localStorage =", savedOwnerId);

    setLoading(false);
  }, []); // run once

  const login = async (email, password) => {
    // ✅ USE ENVIRONMENT VARIABLE FOR LOCAL TESTING
    const API_URL = process.env.REACT_APP_API_URL || "https://fliplyn-b-c.fly.dev";
    const loginEndpoint = `${API_URL}/api/owner/auth/login`;

    const response = await fetch(
      loginEndpoint,
      
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Login Failed");
    }

    const data = await response.json();
    console.log("🟢 Login API Response =", data);

    // Decode JWT to extract owner_id (sub)
    const decoded = jwtDecode(data.access_token);
    console.log("🔍 Decoded Token =", decoded);

    const ownerIdDecoded = decoded.sub;
    console.log("💠 Extracted owner_id from JWT =", ownerIdDecoded);

    // Save to local storage
    localStorage.setItem("kiosk_token", data.access_token);
    localStorage.setItem("kiosk_owner_id", ownerIdDecoded);

    // Update global state
    setToken(data.access_token);
    setOwnerId(ownerIdDecoded);

    console.log("✔ token saved =", data.access_token);
    console.log("✔ owner_id saved =", ownerIdDecoded);
  };

  const logout = () => {
    console.log("🚪 Logout pressed — clearing context and storage");

    // clear localStorage
    localStorage.removeItem("kiosk_token");
    localStorage.removeItem("kiosk_owner_id");

    // reset state
    setToken("");
    setOwnerId("");
  };

  return (
    <KioskAuthContext.Provider
      value={{
        token,
        ownerId,
        kioskUser: { owner_id: ownerId },
        login,
        logout,
        loading,
      }}
    >
      {children}
    </KioskAuthContext.Provider>
  );
}
